import React from "react";

const DroneMapping = () => {
  return (
    <div className="panel drone-mapping-panel">
      <div className="panel-header">
        <h3>Drone Mapping</h3>
        <button type="button" className="link-button">View Details</button>
      </div>
      <img
        src="/dronemap.png"
        alt="Drone Mapping"
        class="map-image"
     />

    </div>
  );
};

export default DroneMapping;
